// @flow

import styled from '@emotion/styled'

import Col from './Col';

const DescriptionCell = styled(Col)`
  flex: 1;
`;

export default DescriptionCell;
